import { Box } from '@bonanza-social/moonlight';
import ClaimStatusBar from './ClaimStatusBar/ClaimStatusBar';
import { useRegistrationPromos } from '../../hooks/useRegistrationPromos';
import { VARIANTS } from './HeaderVariant';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectRegistrationConfigVariant } from '../../state';
import { RegistrationVariantEnum } from '../../utils/fetchRegistrationVariant';

function RegistrationProgressHeader() {
  const ctx = useRegistrationPromos();
  const variant =
    useSelector(selectRegistrationConfigVariant) ??
    RegistrationVariantEnum.elevenStep;

  if (!ctx.referralPromo && !ctx.selectedWelcomePromo) {
    return null;
  }

  const renderHeaderVariant = VARIANTS[variant];

  return (
    <Box
      gap="space-100"
      paddingLeft="space-300"
      paddingRight="space-300"
      paddingTop="space-400"
      width={{
        mobile: '100%',
        tablet: '100%',
        desktop: 760,
      }}
      margin="auto"
    >
      <ClaimStatusBar />
      {renderHeaderVariant(ctx)}
    </Box>
  );
}

export default RegistrationProgressHeader;
